// Web3Forms access keys – each key delivers to the address it's registered to
const INFO_WEB3FORMS_KEY = '1c356b66-d231-4b5b-87b7-77d4e9ef5c8d'
const BOKABORD_WEB3FORMS_KEY = '4fe1d253-ce1a-4a03-b6ab-6294cf0e6251'
export const INFO_EMAIL = 'info@topnotchbakery.se'
export const BOKABORD_EMAIL = 'bokabord@topnotchbakery.se'

interface Mail {
  subject: string
  message: string
  fromName: string
  replyTo: string
}

async function sendWeb3Forms(accessKey: string, mail: Mail): Promise<boolean> {
  try {
    const res = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        access_key: accessKey,
        subject: mail.subject,
        from_name: mail.fromName,
        replyto: mail.replyTo,
        message: mail.message,
      }),
    })
    const json = (await res.json().catch(() => null)) as {
      success?: boolean
    } | null
    return res.ok && !!json?.success
  } catch {
    return false
  }
}

/** Sends a formatted email to info@topnotchbakery.se. Returns true on success. */
export function sendInfoMail(mail: Mail): Promise<boolean> {
  return sendWeb3Forms(INFO_WEB3FORMS_KEY, mail)
}

/** Sends a formatted email to bokabord@topnotchbakery.se. Returns true on success. */
export function sendBokabordMail(mail: Mail): Promise<boolean> {
  return sendWeb3Forms(BOKABORD_WEB3FORMS_KEY, mail)
}
